/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbRespAppliedFilters_user = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespAppliedFilters_user",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedMeasurementUnitProvider_user",
      "args": null
    }
  ],
  "type": "User"
};

module.exports = fragment;
